// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Z90a","validationTips":"StatementDescriptor_validationTips__38wnM"};